import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../resources/UnboardingResourcePackage";
import { UnboardingType } from "./UnboardingType";

export class UnboardingHeaderContainer extends Container {
    private static readonly TOP_TEXT = "CONGRATS! YOU'RE";
    private static readonly BOTTOM_TEXT_RENTER = "IN THIS BUILDING";
    private static readonly BOTTOM_TEXT_OWNER = "OF THESE BUILDINGS";
    private static readonly BOTTOM_TEXT_OWNER_ONE_BUILDING = "OF THIS BUILDING";

    public constructor(unboardingResources: UnboardingResourcePackage, type: UnboardingType, isSeveralBuildings?: boolean) {
        super();
        const topText = new Text(UnboardingHeaderContainer.TOP_TEXT, new ContainerTextStyle());
        const headerSprite = new Sprite();
        const bottomText = new Text(` `, new ContainerTextStyle());
        headerSprite.texture = type === UnboardingType.OWNER ? unboardingResources.assets_views_unboarding_owner_header_png : unboardingResources.assets_views_unboarding_rented_header_png;
        headerSprite.position.set(-134.5, type === UnboardingType.OWNER ? 79 : 90);
        bottomText.text = type === UnboardingType.OWNER ? UnboardingHeaderContainer.BOTTOM_TEXT_OWNER_ONE_BUILDING : UnboardingHeaderContainer.BOTTOM_TEXT_RENTER;
        bottomText.position.set(type === UnboardingType.OWNER ? 15.5 : 18, type === UnboardingType.OWNER ? 281 : 293);
        if (isSeveralBuildings) {
            bottomText.text = UnboardingHeaderContainer.BOTTOM_TEXT_OWNER;
            bottomText.position.x = -19.5;
        }
        this.addChild(topText, headerSprite, bottomText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 72,
            fill: 'ffffff'
        });
    }
}